import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/workflow-api/credit-line/page', params)
//  获取旧数据接口
export const getHistoryData = params =>
  request.post('/workflow-api/credit-line/historyAmount', params)

export const getDialogTableData = params =>
  request.post('/workflow-api/credit-line/reduce/page', params)

export const getDescTran = tran =>
  request.get(`/workflow-api/credit-apply/approve/desc/${tran}`)

export const saveForm = params =>
  request.post('/workflow-api/credit-line/reduce', params, { timeout: 300000 })
export const getCompanyInfo = id =>
  request.get(`/customer-api/customer/overview/${id}`)
